'use strict';

var tealium = require('../tealium');
	

var account = {
    init: function (){
    	if($('.order-details-section').length > 0){
			tealium.triggerEvent({"event_name":"order-status"});
    	}    	
    }
}
exports.init = account.init;
